<div class="location-section">
  <!-- basic order - tabs -->
  <!-- <ul class="nav nav-tabs horizontal-tab" id="location_tab" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" id="map-tab" data-toggle="tab" href="#map" role="tab" aria-controls="map"
        aria-selected="true">الموقع علي الخريطة</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="nationalAddress-tab" data-toggle="tab" href="#nationalAddress" role="tab"
        aria-controls="nationalAddress" aria-selected="false">كود العنوان الوطني </a>
    </li>
  </ul> -->

  <div class="tab-content horizontal-content" id="myTabContent">
    <div class="tab-pane fade show active" id="map" role="tabpanel" aria-labelledby="map-tab">
      <div class="map-wrapper">
        <ayen-map [apiLoaded]="apiLoaded" [mapLabel]="''" #ayenMap [lat]="latitude" [lang]="longitude"
          (mapValues)="mapValues($event)"></ayen-map>
      </div>
    </div>
    <div class="tab-pane fade" id="nationalAddress" role="tabpanel" aria-labelledby="nationalAddress-tab">
      <div class="col-6 form-group">
        <label for="" class="form-label">
          كود العنوان الوطني
        </label>
        <div class="input-group">
          <input type="text" class="form-control" [(ngModel)]="nationalAddressCode"
            (ngModelChange)="formatNationalCode($event)" maxlength="9"
            placeholder="أدخل كود العنوان الوطني (مثال: AAAA 1234)" />
          <div class="input-group-append">
            <button class="btn btn-green" type="button">
              بحث
            </button>
          </div>
        </div>
        @if(hasNationalCodeError) {
        <small class="text-danger">
          يجب ان يبدأ بكود المنطقة (مثال: AAAA) متبوعًا بمسافة ثم 4 أرقام (مثال: 1234)
        </small>
        }
        @if (
            propertyDetailsFormGroup.get('short_address')?.errors?.['pattern'] &&
            (propertyDetailsFormGroup.get('short_address')?.dirty ||
              propertyDetailsFormGroup.get('short_address')?.touched)
          ) {
            <span class="text-danger">
              يجب أن يتكون من 4 أحرف إنجليزية كبيرة متبوعة بـ 4 أرقام (مثال: RRRD2929)
            </span>
          }
      </div>
    </div>
  </div>
  <form [formGroup]="propertyDetailsFormGroup" class="location-form mt-2">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label">المنطقة <span class="red">*</span></label>
          <ng-select 
            [items]="regions" 
            bindLabel="name" 
            bindValue="pk" 
            class="single-select" 
            placeholder="المنطقة" 
            appendTo="body"
            formControlName="address_area" 
            (change)="regionChanged()" 
            [searchable]="true" 
            [clearable]="true">
          </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label">المدينة <span class="red">*</span></label>
          <ng-select 
            [items]="cities" 
            bindLabel="city_name" 
            bindValue="pk" 
            class="single-select" 
            placeholder="المدينة" 
            appendTo="body"
            formControlName="address_city" 
            (change)="getDestrictsByCity()" 
            [searchable]="true" 
            [clearable]="true">
          </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label">الحي <span class="red">*</span></label>
          <ng-select 
            [items]="districts" 
            bindLabel="district_name" 
            bindValue="pk" 
            class="single-select" 
            placeholder="اختر الحي" 
            appendTo="body"
            formControlName="district" 
            [searchable]="true" 
            [clearable]="true">
          </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label">اسم الشارع</label>
          <input type="text" formControlName="address_street" class="form-control" placeholder="ادخل اسم الشارع" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label">كود العنوان الوطني</label>
          <input type="text" class="form-control" formControlName="short_address" (input)="formatNationalCode($any($event.target).value)"
            maxlength="9" placeholder="ادخل كود العنوان الوطني" />
          @if (hasNationalCodeError || isShortAddressInvalid()) {
          <small class="text-danger">
            يجب ان يبدأ بكود المنطقة (مثال: AAAA) متبوعًا بمسافة ثم 4 أرقام (مثال: 1234)
          </small>
          }
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label">رقم المبنى</label>
          <input type="text" formControlName="address_building_code" class="form-control" placeholder="ادخل رقم المبنى" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label">معلم بارز</label>
          <input type="text" formControlName="landmark" class="form-control" placeholder="معلم بارز" />
        </div>
      </div>
    </div>
  </form>
</div>
